@if (consumerReport?.consumers) {
  <div class="sidecard-content">
    <div class="sidecard-row">
      <div><strong>{{ 'content.subject' | translate }}</strong></div>
      @for (consumer of this.consumerReport?.consumers || []; track consumer) {
        <div>
          @if (!isCreditFreezeMessageExists(consumer)) {
            <div >{{ primaryGivenNames(consumer) }} {{ primaryName(consumer)?.lastName }}</div>
          } @else {
            <div>{{getFullNameFromConsumerRequest(consumer,consumerRequest)}}</div>
          }
        </div>
      }
    </div>
    <div>
      <div class="sidecard-row pdf-reactor-d-none">
        <div><strong>{{ 'content.product' | translate }}</strong></div>
        @if (consumerReport?.tracking?.productRequested) {
          <div>{{ consumerReport?.tracking?.productRequested }}</div>
        } @else {
          <div>{{consumerRequest?.metaInfo.product}}</div>
        }
      </div>
      <div class="d-none pdf-reactor-block w-100"></div>
      <div class="sidecard-row pdf-reactor-d-none">
        <div><strong>{{ 'content.language' | translate }}</strong></div>
        @if (consumerReport?.tracking?.reportLanguage) {
          <div>{{ consumerReport?.tracking?.reportLanguage }}</div>
        } @else {
          <div>{{consumerRequest?.metaInfo.lang}}</div>
        }
      </div>
      <div class="sidecard-row">
        <div><strong>{{ 'content.reference-id' | translate }}</strong></div>
        @if (consumerReport?.tracking?.userRefernce) {
          <div>{{ consumerReport?.tracking?.userRefernce.trim() }}</div>
        } @else {
          <div>{{consumerRequest?.metaInfo.userReference}}</div>
        }
      </div>
      <div class="d-none pdf-reactor-block w-100"></div>
      @if (mergeSubjectIdentifiers(consumerReport.consumers).length > 0) {
        <div class="sidecard-row">
          <div><strong>{{ 'content.identifier' | translate }}</strong></div>
          <div>{{ mergeSubjectIdentifiers(consumerReport.consumers).join(', ') }}</div>
        </div>
      }
      <div class="sidecard-row">
        <div><strong>{{ 'content.branch' | translate }}</strong></div>
        <div>{{ consumerRequest?.metaInfo?.branchName }}</div>
      </div>
      <div class="sidecard-row">
        <div><strong>{{ 'content.results-issued' | translate }}</strong></div>
        @if (consumerReport?.tracking?.resultsIssuedDate) {
          <div>{{ reformatDate(consumerReport?.tracking?.resultsIssuedDate, "LLL", "DD/MM/YYYY HH:mm:ss")}}</div>
        } @else {
          <div>{{getCurrentDate()}}</div>
        }
      </div>
    </div>
  </div>
}
